module.exports = __webpack_public_path__ + "img/part-3-title.5343ee11.png";